import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Linking, StyleSheet } from "react-native";
import { Icon } from "~/components/Icon";
import { Screen } from "~/components/Screen";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { environment } from "~/environment";
import { logEvent } from "~/features/analytics/firebaseAnalytics";
import { styleConstants } from "~/style/styleConstants";
import { useErrorAlert } from "../../components/error-alert";

const styles = StyleSheet.create({
  screen: {
    paddingTop: 87,
    paddingHorizontal: styleConstants.spacingExtraLarge,
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: styleConstants.colorBackgroundWhite,
  },
});

export const SmsTosConsentAlreadyAcceptedScreen = observer(
  function SmsTosConsentAlreadyAcceptedScreen() {
    const errorAlert = useErrorAlert();

    useEffect(() => {
      logEvent("terms_already_approved");
    }, []);

    return (
      <Screen
        withBottomInset
        withTopInset={false}
        preventScroll
        style={styles.screen}
      >
        <Spacer extraExtraLarge />
        <Icon name="check" size={56} color={styleConstants.colorTextSuccess} />
        <Spacer extraLarge />
        <Text alignCenter weightBold sizeExtraExtraLarge>
          <FormattedMessage
            id="VJHGax"
            defaultMessage="Accepted"
            description="Text on the success screen after SMS TOS consent."
          />
        </Text>
        <Spacer extraLarge />
        <Text alignCenter weightLight>
          <FormattedMessage
            id="kAqHc0"
            defaultMessage="Nothing to do here! You have already accepted our <tosLink>terms and conditions</tosLink> for your visit."
            description="Text on already accepted screen after SMS TOS consent which informs the user that they have already accepted the general terms and conditions."
            values={{
              tosLink: (chunks: React.ReactNode) => (
                <Text
                  weightBold
                  onPress={async () => {
                    try {
                      await Linking.openURL(environment.TOS_URL);
                    } catch (error) {
                      console.log("Error opening TOS link", error);
                      errorAlert(error);
                    }
                  }}
                  style={{
                    color: styleConstants.colorTextTheme,
                    textDecorationLine: "underline",
                  }}
                >
                  {chunks}
                </Text>
              ),
            }}
          />
        </Text>
      </Screen>
    );
  },
);
